module.exports = __webpack_public_path__ + "static/RamyaSuresh.02100d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/RamyaSuresh.jpg
// module id = 245
// module chunks = 25111403944408 251948199435738